import { Textarea } from "./ui/textarea";
import { useConfigStore } from "../stores/widget-store";
import { useCallback } from "react";

export const SkipLinkTargetsInput = () => {
  const { config, setFixes } = useConfigStore();

  // Handle textarea change
  const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    
    // Store the raw input value as a single string
    setFixes("enableSkipLink.targets", value);
  }, [setFixes]);

  return (
    <div className="cy:mt-4 cy:pl-14">
      <div className="cy:max-w-md">
        <label className="cy:block cy:text-sm cy:font-medium cy:text-gray-700 cy:mb-2">
          Define the ID(s) of the main content area(s)
        </label>
        <Textarea
          placeholder="Enter multiple IDs separated by commas (e.g., #main, #content, #primary)"
          rows={3}
          value={config.fixes.enableSkipLink?.targets}
          onChange={handleChange}
        />
        <p className="cy:mt-1 cy:text-xs cy:text-gray-500">
          The system will cascade through the list to find the appropriate one for each page.
        </p>
      </div>
    </div>
  );
}; 